export enum ServiceKind {
  STANDARD = "standard",
  MEETING = "meeting",
  PACKAGE = "package",
}

export enum BookingConfirmation {
  AUTOMATIC = "automatic",
  MANUAL = "manual",
  OPTIMISTIC = "optimistic",
}

export enum ServicePricingType {
  PRICING = "pricing",
  DESCRIPTION = "description",
  NONE = "none",
}
